<script setup></script>

<template>
  <v-row align="center" class="fill-height ma-0" justify="center">
    <v-progress-circular color="grey-lighten-5" indeterminate></v-progress-circular>
  </v-row>
</template>

<style lang="less" scoped></style>